import * as React from 'react'
import { MapPin, Phone, Video } from 'lucide-react'
import { EventTypeLocationType } from '../../types'

export const ORGANIZER_LOCATIONS = [EventTypeLocationType.IN_PERSON_ORGANIZER, EventTypeLocationType.PHONE_ORGANIZER]
export const ATTENDEE_LOCATIONS = [EventTypeLocationType.IN_PERSON_ATTENDEE, EventTypeLocationType.PHONE_ATTENDEE]
export const PHONE_LOCATIONS = [EventTypeLocationType.PHONE_ORGANIZER, EventTypeLocationType.PHONE_ATTENDEE]
export const CONFERENCING_LOCATIONS = [EventTypeLocationType.GOOGLE_MEET, EventTypeLocationType.MICROSOFT_TEAMS]

export const isOrganizerLocation = (type: EventTypeLocationType | null) => !!type && ORGANIZER_LOCATIONS.includes(type)
export const isAttendeeLocation = (type: EventTypeLocationType | null) => !!type && ATTENDEE_LOCATIONS.includes(type)
export const isPhoneLocation = (type: EventTypeLocationType | null) => !!type && PHONE_LOCATIONS.includes(type)

export function LocationIcon({ type, className }: { type: EventTypeLocationType | null, className?: string }) {
  if (isPhoneLocation(type)) return <Phone className={className} />
  if (type === EventTypeLocationType.IN_PERSON_ORGANIZER || type === EventTypeLocationType.IN_PERSON_ATTENDEE) return <MapPin className={className} />
  return <Video className={className} />
}
